import {
    AfterViewInit,
    Directive,
    ElementRef,
    HostBinding,
    HostListener,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';

@Directive({
    selector: '[appPopoverTrigger]'
})
export class PopoverTriggerDirective implements AfterViewInit, OnDestroy {
    unsubscribe$ = new Subject();
    private _$isExpanded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    $isExpanded = this._$isExpanded.asObservable().pipe(distinctUntilChanged());

    get isExpanded(): boolean {
        return this._$isExpanded.value;
    }

    @HostBinding('attr.aria-expanded') expanded = this.isExpanded;
    @HostListener('keydown.arrowdown', ['$event'])
    @HostListener('click', ['$event'])
    toggle = (event: Event | KeyboardEvent) => {
        if ('key' in event && event.key === 'ArrowDown') {
            // open popover on arrow down by not stopping event propagation
            /*if (this.isOpen) {
        this.popoverElement.nativeElement.close();
      } else {
        this.popoverElement.nativeElement.open();
        // prevent container from scrolling
        event.preventDefault();
      }*/
        } else {
            if (this.isExpanded) {
                this.collapse();
            } else {
                this.expand();
                // prevent container from scrolling
                event.preventDefault();
            }
        }
    };
    constructor(public elRef: ElementRef) {}

    expand() {
        this._$isExpanded.next(true);
    }

    collapse() {
        this._$isExpanded.next(false);
    }

    ngAfterViewInit() {
        this.$isExpanded
            .pipe(
                tap((isExpanded) => (this.expanded = isExpanded)),
                takeUntil(this.unsubscribe$)
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
